import { selectCurrency } from '@/redux/config/configSlice';
import { selectActiveTicket } from '@/redux/data/dataSlice';
import { useAppSelector } from '@/redux/hooks';
import { getTicketTotal } from '@/utils/ticket';
import { Button } from 'antd';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ChargeBtnProps {
  onPress: (id: string) => void;
}

const ChargeBtn: FC<ChargeBtnProps> = ({ onPress }) => {
  const { t } = useTranslation();
  const activeTicket = useAppSelector(selectActiveTicket);
  const currency = useAppSelector(selectCurrency);

  const total = useMemo(() => {
    return getTicketTotal(activeTicket);
  }, [activeTicket]);

  const handlePress = () => {
    if (activeTicket?.ID) {
      onPress(activeTicket.ID);
    }
  };

  const isDisabled = !activeTicket || Number(total) <= 0;

  return (
    <Button
      type="primary"
      size="large"
      disabled={isDisabled}
      onClick={handlePress}
      className={`
        w-full h-12 rounded-lg
        transition-all duration-300 ease-in-out
        transform hover:scale-[1.02] active:scale-[0.98]
        shadow-lg hover:shadow-xl
        ${
          isDisabled
            ? 'bg-gray-300 cursor-not-allowed opacity-60'
            : 'bg-gradient-to-r from-primary to-primary-dark hover:from-primary-dark hover:to-primary'
        }
      `}
    >
      <div className="flex flex-col items-center gap-0.5">
        <span className="text-white text-xs font-semibold tracking-wide">{t('common:charge')}</span>
        <span className="text-white text-sm font-bold tracking-wider">
          {total} {currency}
        </span>
      </div>
    </Button>
  );
};

export default ChargeBtn;
